import {
  boolean,
  minLength,
  minValue,
  number,
  object,
  optional,
  pipe,
  string,
  regex,
  check,
  email,
  required,
  nonEmpty,
} from "valibot";

export const loginSchema = object({
  email: pipe(string(), nonEmpty("Email is required"), email()),
  password: pipe(
    string(),
    nonEmpty("Password is required"),
    minLength(6, "Password must be at least 6 characters")
  ),
});

export type LoginForm = {
  email: string;
  password: string;
};

export const phoneNumberGetStartedSchema = object({
  phoneNumber: pipe(
    string(),
    nonEmpty("Phone number is required"),
    minLength(9, "Phone number must be at least 9 digits")
  ),
  phoneNumberCountryCode: pipe(string(), nonEmpty("Country code is required")),
});

export const forgotPasswordSchema = object({
  email: pipe(string(), nonEmpty("Email is required"), email()),
});

export type ForgotPasswordForm = {
  email: string;
};

export const resetPasswordSchema = object({
  password: pipe(
    string(),
    nonEmpty("Password is required"),
    minLength(8, "Password must be at least 8 characters"),
    regex(/[A-Za-z]/, "Password must contain a letter"),
    regex(/\d/, "Password must contain a number")
  ),
  confirmPassword: pipe(string(), nonEmpty("Please confirm your password")),
});

export type ResetPasswordForm = {
  password: string;
  confirmPassword: string;
};
